import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function nav() {
  gsap.registerPlugin(ScrollTrigger);

  const navLinks = document.querySelectorAll('.p-top-nav__link');
  const navHeight = document.querySelector('.p-top-nav').offsetHeight;

  navLinks.forEach(link => {
    const targetId = link.getAttribute('href').substring(1);
    const targetSection = document.getElementById(targetId);

    if (targetSection) {
      ScrollTrigger.create({
        trigger: targetSection,
        start: `top ${navHeight + 1}px`,
        end: `bottom ${navHeight + 1}px`,
        onEnter: () => setActiveLink(link),
        onEnterBack: () => setActiveLink(link),
        onLeave: () => removeActiveLink(link),
        onLeaveBack: () => removeActiveLink(link)
      });
    }
  });

  function setActiveLink(activeLink) {
    navLinks.forEach(link => link.classList.remove('active'));
    activeLink.classList.add('active');
  }

  function removeActiveLink(link) {
    link.classList.remove('active');
  }
}